import { makeSelectCall } from "_state/api";

const selectAccounts = makeSelectCall("/account/query");

export { selectAccounts };
